<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.invoice.studentUnpaidInvoices')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <!-- Filters -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('filters')}}</div>
                        <div class="text-right">
                            <b-button variant="primary" size="sm" @click="detailedSearch = !detailedSearch">
                                {{$t('button.detailedSearch')}}</b-button>
                            <b-button variant="default" size="sm" @click="clearSearch()">{{$t('button.resetFilter')}}
                            </b-button>
                        </div>
                    </div>
                    <div class="card-body">

                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.searchCriteria')}}</label>
                                    <v-select @input="loadPreset" label="name" :options="presetList" v-model="preset">
                                    </v-select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.invoiceNumber')}}</label>
                                    <input type="text" v-model="search.number" @keyup="searchInvoice"
                                        class="form-control">
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.studentNo')}}</label>
                                    <input type="number" @keyup="searchInvoice" v-model="search.studentNumber" class="form-control">
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.status')}}</label>
                                    <v-select @input="searchInvoice" v-model="search.status" :options="statusArray">
                                    </v-select>
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.invoiceDate')}}</label>
                                    <date-picker :lang="lang" class="date-picker" v-model="search.invoiceDate" valueType="format"
                                        :format="dateFormat" @change="searchInvoice"
                                        :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                                    </date-picker>
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.dueDate')}}</label>
                                    <date-picker :lang="lang" class="date-picker" v-model="search.dueDate" valueType="format"
                                        :format="dateFormat" @change="searchInvoice"
                                        :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                                    </date-picker>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="detailedSearch">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.amount')}}</label>
                                    <input type="text" v-model="search.amount" @keyup="searchInvoice"
                                        class="form-control">
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.currency')}}</label>
                                    <v-select @input="searchInvoice" :options="currencies" v-model="search.currency"
                                        :reduce="currencies => currencies"></v-select>
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.invoicePurpose')}}</label>
                                    <v-select @input="searchInvoice" :options="invoicePurposes"
                                        v-model="search.invoicePurpose" :reduce="invoicePurposes => invoicePurposes">
                                    </v-select>
                                </div>
                            </div>

                            <!-- <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.paid')}}</label>
                                    <select @change="searchInvoice" v-model="search.paid" class="form-control">
                                        <option value="">{{$t('form.invoice.select')}}</option>
                                        <option value="-1">{{$t('form.invoice.yes')}}</option>
                                        <option value="0">{{$t('form.invoice.no')}}</option>
                                    </select>
                                </div>
                            </div> -->

                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.paymentDate')}}</label>
                                    <date-picker :lang="lang" class="date-picker" v-model="search.paymentDate" valueType="format"
                                        :format="dateFormat" @change="searchInvoice"
                                        :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                                        :popup-style="{ top: '100%', left: 0}" :append-to-body="false" </date-picker>
                                </div>
                            </div>

                            <div class="col-12">
                                <hr>
                            </div>

                            <div class="col-sm-6">
                                <div class="form-group">
                                    <input type="text" v-model="preset.name" class="form-control"
                                        :placeholder="$t('form.book.presetName')">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <button class="btn btn-primary" @click="savePreset">{{$t('button.save')}}</button>
                                <button class="btn btn-danger" v-show="presetSelected"
                                    @click="deletePreset">{{$t('button.delete')}}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- List -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.invoice.studentUnpaidInvoices')}}</div>
                    </div>
                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="invoices.length">
                            <thead>
                                <tr>
                                    <th>{{$t('form.invoice.number')}}</th>
                                    <th>{{$t('form.invoice.status')}}</th>
                                    <th>{{$t('form.invoice.studentNumber')}}</th>
                                    <th>{{$t('form.invoice.date')}}</th>
                                    <th>{{$t('form.invoice.dueDate')}}</th>
                                    <th>{{$t('form.invoice.amount')}}</th>
                                    <th>{{$t('form.invoice.invoicePurpose')}}</th>
                                    <th>{{$t('form.invoice.payment')}}</th>
                                    <th>{{$t('form.invoice.installment')}}</th>
                                    <!-- <th>{{$t('form.invoice.paid')}}</th> -->
                                    <th>{{$t('form.invoice.paymentDate')}}</th>
                                    <th class="text-right">{{$t('form.invoice.action')}}</th>
                                </tr>
                            </thead>
                            <tbody v-for="(invoice, index) in invoices" v-bind:key="index">
                                <tr @dblclick="goToEdit(invoice.ID)">
                                    <td>{{invoice.InvoiceNumber}}</td>
                                    <td v-if="invoice.Status==1">{{$t('form.invoice.status_pending')}}</td>
                                    <td v-else-if="invoice.Status==2">{{$t('form.invoice.status_approved')}}</td>
                                    <td v-else-if="invoice.Status==3">{{$t('form.invoice.status_sent')}}</td>
                                    <td v-else-if="invoice.Status==4">{{$t('form.invoice.status_paid')}}</td>
                                    <td v-else-if="invoice.Status==5">{{$t('form.invoice.status_delivery_failed')}}</td>

                                    <td v-else-if="invoice.Status==null ||invoice.Status==undefined ||invoice.Status==0"></td>

                                    <td>
                                        <template v-if="invoice.student.length">
                                            <router-link
                                                :to="{name: 'StudentEdit', params: {id: invoice.student[0].StudentNumber}}">
                                                {{invoice.student[0].StudentNumber}}
                                            </router-link>
                                        </template>
                                    </td>
                                    <td>{{invoice.InvoiceDate | formatDate(dateFormat)}}</td>
                                    <td>{{invoice.DueDate | formatDate(dateFormat)}}</td>
                                    <td>
                                        <template v-if="invoice.Discount > 0 && invoice.PaymentPlan != 'Full Payment' && !invoice.acceptanceFee">
                                            <!-- <del>{{invoice.Currency}}
                                                {{invoice.Amount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</del> -->
                                            {{invoice.Currency}}
                                            {{invoice.DiscountedAmount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}
                                            ({{invoice.Discount}}% {{$t('form.invoice.discount')}})
                                        </template>
                                        <template v-else-if="invoice.Version === 'V1' && invoice.PaymentPlan === 'Full Payment' && !invoice.acceptanceFee">
                                            {{ invoice.Currency }}
                                            {{ invoice.FullPaymentDiscountedAmount | curreny(decimalDigits, decimalPoint, thousandSeparator) }}
                                        </template>
                                        <template v-else-if="invoice.Version === 'V2' && invoice.PaymentPlan === 'Full Payment' && !invoice.acceptanceFee">
                                            {{invoice.Currency}}
                                            {{invoice.Total | curreny(decimalDigits, decimalPoint, thousandSeparator)}}
                                        </template>
                                        <template v-else>
                                            {{invoice.Currency}}
                                            {{invoice.Amount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}
                                        </template>
                                        <!-- <template v-if="invoice.Discount > 0">
                                            <del>{{invoice.Amount}} {{invoice.Currency}}</del>
                                            {{invoice.DiscountedAmount}} {{invoice.Currency}}
                                            ({{invoice.Discount}}% {{$t('form.invoice.discount')}})
                                        </template>
                                        <template v-else>
                                            {{invoice.Amount}} {{invoice.Currency}}
                                        </template> -->
                                    </td>
                                    <td>{{invoice.InvoicePurpose}}</td>
                                    <td>{{invoice.PaymentPlan | capitalize}}</td>
                                    <td>{{invoice.Installment}}</td>
                                    <!-- <td>
                                        <i class="fas fa-check text-success" :title="$t('form.invoice.paid')"
                                            v-if="invoice.Paid == -1"></i>
                                        <i class="fas fa-times text-danger" :title="$t('form.invoice.unpaid')"
                                            v-else></i>
                                    </td> -->
                                    <td>{{invoice.PaymentDate | formatDate(dateFormat)}}</td>
                                    <td class="text-right">
                                        <button v-if="permissions.viewInvoices" @click="goToShow(invoice.ID)"
                                            class="btn btn-dark btn-sm">
                                            <i class="fa fa-print"></i>
                                        </button>
                                        <button v-if="permissions.viewInvoicesStudents" @click="goToEdit(invoice.ID)"
                                            class="btn btn-info btn-sm">
                                            <i class="fa fa-edit"></i>
                                        </button>
                                        <button class="btn btn-danger btn btn-sm" v-on:click="deleteInvoice(invoice)"
                                            v-show="permissions.deleteInvoicesStudents">
                                            <span class="fa fa-trash"></span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>
                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions', 'dateFormat', 'decimalDigits', 'decimalPoint', 'thousandSeparator'],

        data() {
            return {

                alert: false,
                alertClass: '',
                alertMessage: '',

                statusArray:[],
                status:'',

                isLoading: false,
                fullPage: true,

                request_source: '',
                detailedSearch: false,
                presetSelected: false,

                pagination: {
                    current_page: 1
                },
                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },
                search: {
                    paid: '',
                    invoicePurpose: '',
                    currency: '',
                    status:'',
                    number:'',
                    studentNumber:''
                },

                preset: {
                    name: '',
                    entity: 'studentUnpaidInvoice',
                    value: {}
                },

                invoicePurposes: [],
                currencies: [],
                presetList: [],
                invoices: []
            }
        },

        async mounted() {
            this.isLoading = true;

            if (!this.permissions.viewInvoicesStudents) {
                return this.$router.push('/');
            }

            await this.getInitialData();

            if (localStorage.getItem('filter-sinvoice-unpaid')) {
                this.search = JSON.parse(localStorage.getItem('filter-sinvoice-unpaid'));
            }

            this.getAllStatus();
            this.getInvoices();
            this.getPresets();
        },

        watch: {
            search: {
                handler(newSearch) {
                    localStorage.setItem('filter-sinvoice-unpaid', JSON.stringify(this.search));

                    const emojiRegex = /[\u{10000}-\u{10FFFF}]/gu;
                    
                    // Loop through all properties in the search object
                    Object.keys(newSearch).forEach(key => {
                    // Only process string values
                    if (typeof newSearch[key] === 'string' && emojiRegex.test(newSearch[key])) {
                        // Strip the emoji and update the reactive property
                        this.search[key] = newSearch[key].replace(emojiRegex, '');
                    }
                    });
                },
                deep: true  
            }
        },

        methods: {
            /**
             * Delete invoice
             */
            deleteInvoice(invoice) {

                if(!this.permissions.deleteInvoicesStudents){
                    this.showAlert(this.$t('form.validation.cantDeleteInvoice'),'danger');
                    return;
                }
                var index = invoice.ID;

                if(invoice.Status == 3){
                var conf = confirm(this.$t('form.validation.deleteSentInvoice'));
                }else if(invoice.Status == 4){
                var conf = confirm(this.$t('form.validation.deletePaidInvoice'));
                }else{
                var conf = confirm(this.$t('form.validation.delete'));
                }

                if (conf === true) {
                    this.isLoading = true;
                    axios
                        .delete("/api/invoices/" + index)
                        .then(response => {
                            this.isLoading = false;
                            this.invoices.splice(index, 1);
                            this.showAlert(response.data.message);
                            this.getInvoices();
                        })
                        .catch(error => {
                            this.isLoading = false;
                            this.showAlert(error.response.data.message,'danger');
                        });
                }
            },
            
            /**
             * get all invoice status from config
             */

            getAllStatus() {
                let self = this;
                return new Promise(function(resolve, reject) {
                axios.get('/api/config')
                .then(response => {
                if (response.data) {
                    let config = response.data;
                    self.status = config.status;
                    if (( typeof self.status == 'object') && (self.status != '')) {
                            self.statusArray = Object.keys(self.status);
                        }
                    }
                })
                resolve('successfully got config values');
                });
            },

            getDate(date){
                var dateVar  = date?moment(date).format(this.dateFormat):moment().format(this.dateFormat)
                return dateVar;
            },
            /**
             * Build Query String for Filters
             */
            buildQueryString(obj) {
                let query = '';

                Object.keys(obj).forEach(function (key) {
                    if (obj[key] != '' && obj[key] != null) {
                        query += `${key}=${encodeURIComponent(obj[key])}&`;
                    }
                });

                if (this.pagination && this.pagination.current_page) {
                    query += `page=${this.pagination.current_page}`;
                    return query;
                }

                return query.slice(0, -1);
            },

            async getInitialData() {
                await axios
                    .get('/api/invoices/get-initial-data')
                    .then(response => {
                        this.invoicePurposes = response.data.invoice_purposes;
                        this.currencies = response.data.currencies;
                    });
            },

            async getInvoices() {
                this.isLoading = true;

                let filters = await this.buildQueryString(this.search);

                axios
                    .get(`/api/invoices?type=student&paid=0&${filters}`, {
                        cancelToken: this.request_source.token
                    })
                    .then(response => {
                        this.isLoading = false;

                        this.invoices = response.data.data.data;
                        this.pagination = response.data.pagination;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            paginate() {
                this.getInvoices();
            },

            searchInvoice() {
                this.pagination.current_page = 1;
                this.getInvoices();
            },

            // Clear search input fields
            clearSearch() {
                this.search = {
                    paid: '',
                    invoicePurpose: '',
                    currency: '',
                    status: '',
                    number:''
                };

                this.searchInvoice();
            },

            goToShow(id, version) {
                if (!this.permissions.viewInvoices) return;

                this.$router.push({
                    name: version === "V1" ? "InvoiceShowV1": "InvoiceShowV2",

                    params: {
                        id: id
                    }
                });
            },

            goToEdit(id) {
                if (!this.permissions.viewInvoicesStudents) return;

                this.$router.push({
                    name: 'StudentInvoiceEdit',
                    params: {
                        id: id
                    }
                });
            },

            // Save a Preset with Unique Name
            savePreset() {
                this.isLoading = true;
                this.alert = false;

                this.preset.value = JSON.stringify(this.search);

                axios
                    .post('/api/presets', this.preset)
                    .then(response => {
                        this.isLoading = false;
                        this.showAlert(response.data.message);
                        this.getPresets();
                    }, error => {
                        this.isLoading = false;

                        if (error.response.status == 422) {
                            this.showAlert(error.response.data.errors.name[0], 'danger');
                        }
                    });
            },

            // Get Presets in Search Criteria
            getPresets() {
                axios
                    .get('/api/presets/?entity=' + this.preset.entity)
                    .then(response => {
                        this.presetList = response.data;
                    }, error => {
                        console.log(error.response);
                    });
            },

            // Get Search results according to selected Preset Name
            loadPreset() {
                if (!this.preset) {
                    this.preset = {
                        entity: 'studentUnpaidInvoice'
                    };
                    this.clearSearch();
                    this.alert = false;
                    this.presetSelected = false;
                    return;
                }
                this.alert = false;
                this.presetSelected = true;
                this.search = JSON.parse(this.preset.value);
                this.searchInvoice();
            },

            // Delete a selected Preset
            deletePreset() {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    axios
                        .delete("/api/presets/" + this.preset.id)
                        .then(response => {
                            if (response.data.status == 'success') {
                                this.showAlert(response.data.message);
                                this.getPresets();
                                this.clearSearch();
                                this.preset.name = '';
                                this.preset.value = {};
                                this.presetSelected = false;
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;
                        });
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>
